import { Modal, Select, message } from "antd";
import { useEffect, useState } from "react";
import WidgetBlocks from "../blocks";

export default function EditWidgetModal({
  item,
  widgets,
  onCancel,
  onAfterEdit,
}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(item);
  }, [item]);

  const onSave = () => {
    const widget = widgets.find((w) => w.data.key === data.type);
    let hasErrors = false;
    widget?.data?.inputs?.map((input) => {
      const required = input?.required || false;
      if (required) {
        if (!data?.data?.[input.key]) {
          hasErrors = true;
          return message.error(`Field '${input.label}' is required`, 2);
        }
        if (input.type === "images" && data?.data?.[input.key]?.length === 0) {
          hasErrors = true;
          return message.error(`Field '${input.label}' is required`, 2);
        }
      }
    });

    if (!hasErrors) {
      onAfterEdit(data);
      message.info("Content widget updated successfully", 1);
    }
  };

  if (!data || !item) {
    return;
  }

  return (
    <Modal
      destroyOnClose
      title="Edit content widget"
      centered
      open={!!item}
      onCancel={onCancel}
      okText="Save"
      onOk={onSave}
    >
      <div className="grid grid-cols-12 gap-4 my-5">
        <div className="col-span-12">
          <Select
            disabled
            value={data?.type}
            onChange={(key) =>
              setData({
                type: key,
                name: widgets.find((w) => w.data.key === key)?.data?.name,
              })
            }
            className="w-full"
            placeholder="Select content type"
          >
            {widgets.map((item, key) => (
              <Select.Option key={item.data.key} value={item.data.key}>
                {item.data.name}
              </Select.Option>
            ))}
          </Select>
          <WidgetBlocks
            widgets={widgets}
            data={data}
            onChange={(key, value) =>
              setData({ ...data, data: { ...data?.data, [key]: value } })
            }
            onOptionChange={(key, value) =>
              setData({ ...data, options: { ...data?.options, [key]: value } })
            }
          />
        </div>
      </div>
    </Modal>
  );
}
